/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'typetxt': {
    width: 200,
    height: 233.186,
    viewBox: '0 0 200 233.186',
    data: '<g fill-rule="evenodd"><path pid="0" d="M200 196.39V61.84c0-8.29-3.29-16.24-9.15-22.1L160.26 9.15A31.252 31.252 0 00138.16 0H36.8C16.47 0 0 16.48 0 36.8v159.59c0 20.32 16.48 36.8 36.8 36.8h126.4c20.33 0 36.8-16.48 36.8-36.8z" _fill="#4fd397"/><path pid="1" d="M160.258 9.156a31.222 31.222 0 00-16.08-8.57v34.34c0 10.9 8.84 19.74 19.74 19.74h35.24a31.224 31.224 0 00-8.31-14.92l-30.59-30.59zm-13.104 79.812c0-3.45-2.8-6.25-6.25-6.25h-39.65a6.24 6.24 0 00-2.51 0h-39.65c-3.45 0-6.25 2.8-6.25 6.25s2.8 6.25 6.25 6.25h34.66v67.36c0 3.45 2.8 6.25 6.24 6.25 3.45 0 6.25-2.8 6.25-6.25v-67.36h34.66c3.45 0 6.25-2.8 6.25-6.25z" _fill="#19bc6e"/><path pid="2" d="M106.244 92.094h34.66c3.45 0 6.25-2.8 6.25-6.25s-2.8-6.25-6.25-6.25h-39.65a6.24 6.24 0 00-2.51 0h-39.65c-3.45 0-6.25 2.8-6.25 6.25s2.8 6.25 6.25 6.25h34.66v67.36c0 3.45 2.8 6.25 6.24 6.25 3.45 0 6.25-2.8 6.25-6.25v-67.36z" _fill="#fff"/></g>'
  }
})
